/** Dataspace details and environment variables. */

export default {
	dataspace: {
		empty: {
			title: "No dataspaces yet",
			hint: "Create a dataspace to get started.",
		},
		create: "Create dataspace",
		created: "Created {name}.",
		deleted: "Deleted {name}.",
		deleteConfirm: "Delete {name}?",
		deleteNote: "Its processes and their saved state go with it. This cannot be undone.",
		noResults: {
			title: "No matching dataspaces",
			hint: "Nothing matches this search. Try another term, or clear it.",
		},
		column: {
			dataspace: "Dataspace",
			updated: "Updated",
		},
		meta: {
			members: "Members",
			created: "Created",
			updated: "Updated",
		},
		settings: {
			general: "General",
			environment: "Environment",
			telephony: "Telephony",
		},
		search: "Search dataspaces…",
		resultCount: "{n} of {total}",
		openDesigner: "Open Designer",
		version: "Project version",
		versionHelp:
			"Only a version built on this server can run. wip follows the project as it is edited.",
		versionWip: "wip — the project as it is now",
		versionRelease: "v{version}",
		versionReleaseTitled: "v{version} — {title}",
		versionCurrent: "{version} (no build any more)",
		versionNotBuilt:
			"Version {version} has no build on this server, so it cannot run. Choose another version.",
		project: "Project",
		details: "Details",
		delete: "Delete dataspace",
		removeMemberConfirm: "Remove {name} from this dataspace?",
		members: {
			remove: "Remove {name}",
			removed: "Removed {name}.",
			removeNote:
				"They lose access to this dataspace and its processes. They can be invited again.",
			roleChanged: "Changed the role of {name}.",
		},
	},
	env: {
		title: "Environment variables",
		name: "Name",
		value: "Value",
		saved: "Environment variables saved.",
		empty: "No variables to set",
		noBuild:
			"The build of this project version declares no variables, or it has not been built yet.",
		resizeName: "Width of the name column",
		removeStale: "Remove {name}",
		notSet: "not set",
		defaultWithheld: "Server default withheld",
		defaultWithheldWhy:
			"The server's gateway token goes only to the server's gateway, and this dataspace's NOTITIA_LLM_GATEWAY_URL names another one. Clear that URL to use the server's gateway and its token, or set a token of this dataspace's own.",
		serverDefault: "Server default",
		overridesDefault: "Overrides default",
		defaultRefused: "Default not used",
		useDefault: "Use the server default for {name}",
		refuseDefault: "Don't use the server default for {name}",
		defaultsNote:
			"Server defaults come from the control center. An empty field uses its default, shown greyed out. Running processes keep the values they started with; the next start or restart takes the new ones.",
		stale: {
			title: "Stale variables",
			hint: "These variables are stored but no longer declared in the current build. They will be removed when you save.",
		},
		outdated: {
			title: "{n} running process still uses the previous values | {n} running processes still use the previous values",
			note: "A running process keeps the values it started with; a restart takes the new ones.",
			saveFirst: "Save your changes first, so the restart takes them.",
			restartAll: "Restart all running",
			confirmTitle: "Restart {n} running process? | Restart {n} running processes?",
			confirmNote:
				"Each continues where it stopped, with the new values. A process built before resume starts again from scratch, and what it holds now is lost. Restart rules do not apply here — a process whose rule refuses a restart is restarted too. Restarting never changes a process's version; an upgrade is a separate step, and best-effort.",
			confirm: "Restart",
			restarted: "Restarted {n} process. | Restarted {n} processes.",
			nothing: "No process needed a restart any more.",
		},
	},
};
